var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",on:{"drop":function($event){$event.preventDefault();},"dragover":function($event){$event.preventDefault();},"dragleave":function($event){$event.preventDefault();}}},[_c('Nav'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }